import React  from 'react';
import ColorComponentProto from './color-proto';

export default function renderColorInList(id, props) {
    return <ColorComponentProto renderMode="list" id={id} {...props} />;
}